import {
  ConfigurationPageType,
  ConfigurationPageModelConstruction,
} from "../interfaces";

export const SETUP_MODEL_PAGE: ConfigurationPageModelConstruction = {
  type: ConfigurationPageType.MODEL_CONSTRUCTION,
  label: "MODEL_CONSTRUCTION_MENU",
  menuLabel: "MODELS",
  name: "setup_model",
  path: "model",
  hideInMenu: true,
  description: "CONF_DESC_SETUP_MODELS",
};
